import axios from "../../public Func/axiosAuth";

const baseUrl = `${process.env.REACT_APP_BACKEND_URL}/admin/payments`;

export const getPaymentsOverview = async () => {
  const response = await axios.get(`${baseUrl}/overview`);
  return response.data;
};

export const getPaymentsRevenueOvertime = async () => {
  const response = await axios.get(`${baseUrl}/revenue-overtime`);
  return response.data;
};

export const getPaymentsDoctors = async () => {
  const response = await axios.get(`${baseUrl}/doctors`);
  return response.data;
};

export const getDoctorPayments = async (doctorId) => {
  const response = await axios.get(`${baseUrl}/doctor-payments`, {
    params: { doctorID: doctorId },
  });
  return response.data;
};

export const uploadReceipt = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/upload`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  if (typeof response.data === "string") return response.data;
  return response.data?.link || response.data?.file || response.data?.url;
};

export const transferMonthPayments = async ({
  doctorID,
  year,
  month,
  receipt,
}) => {
  const response = await axios.post(`${baseUrl}/transfer-month`, {
    doctorID,
    year,
    month,
    receipt,
  });
  return response.data;
};
